import { Form, FormItemProps } from "antd";
import classNames from "classnames";
export interface HubFormItemProps extends FormItemProps {
  error?: any | any[];
}
export const HubFormItem = ({
  error,
  ...props
}: HubFormItemProps) => {
  if (Array.isArray(error)) {
    error = error[0];
  }
  return <Form.Item help={error?.message || ""} validateStatus={error ? "error" : ""} {...props} className={classNames(props.className, "text-sm [&_.ant-form-item-label]:!pb-1 [&_label]:w-full")} data-sentry-element="unknown" data-sentry-component="HubFormItem" data-sentry-source-file="HubFormItem.tsx" />;
};